import { useState } from 'react'

import {
  Accordion,
  Box,
  Button,
  Icon,
  Input,
  Modal,
  Text,
} from '@fairfashion/design-system'

import { IProductionProvider } from '../../../../sdk/order-production/order-production.types'

import { OrderProductionStepsModalProps } from './order-production-steps-modal.types'

export const OrderProductionStepsModal = ({
  data,
}: OrderProductionStepsModalProps) => {
  const [open, setOpen] = useState(false)

  const getAddress = (provider: IProductionProvider) => {
    const address = provider?.address

    if (address) {
      return `${address.city} - ${address.state}`
    }
  }

  if (!data) return null

  return (
    <>
      <Button variant="text" padding="0" onClick={() => setOpen(true)}>
        <Icon name="building3" size={24} color="secondary" />
      </Button>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title="Etapas das Ordens de Produção"
        width="900px"
        maxWidth="90%"
      >
        <Box padding={2} gap={2} direction="column" width="100%">
          <Box direction="column" marginBottom={1}>
            <Text>Ordens de produção</Text>
            <Text size="small" color="grey_3">
              {`${data.orderProductions?.map((op) => op.code).join(', ')}`}
            </Text>
          </Box>

          {data.steps.map((step, index) => (
            <Accordion
              key={`step-${index}`}
              header={
                <Box gap={2}>
                  <Text size="small" color="grey_3">
                    Etapa
                  </Text>
                  <Text>{step.name}</Text>
                </Box>
              }
            >
              {step.productionProviders.map((provider, providerIndex) => (
                <Box
                  width="100%"
                  key={`production-provider-${providerIndex}`}
                  gap={1}
                >
                  <Box width="55px">
                    <Input
                      disabled
                      value={`${providerIndex + 1}`}
                      label={providerIndex === 0 ? 'Linha' : undefined}
                    />
                  </Box>
                  <Box flex={4}>
                    <Input
                      disabled
                      value={`${provider.name}`}
                      label={providerIndex === 0 ? 'Fornecedor' : undefined}
                    />
                  </Box>
                  <Box flex={2}>
                    <Input
                      disabled
                      value={`${getAddress(provider)}`}
                      label={providerIndex === 0 ? 'Endereço' : undefined}
                      placeholder=" "
                    />
                  </Box>
                  <Box flex={1}>
                    <Input
                      disabled
                      value={`${provider.invoices.map((i) => i.code).join(', ')}`}
                      label={providerIndex === 0 ? 'NFs' : undefined}
                      placeholder=" "
                    />
                  </Box>
                </Box>
              ))}
            </Accordion>
          ))}
        </Box>
      </Modal>
    </>
  )
}
